
    var riot = require('riot')
    //src: starling/src/tags/menu/items/menu-item-edit-attribute.html
riot.tag2('menu-item-edit-attribute',
  '<svg class="floating-menu_icon"> <use xlink:href="#edit-icon"></use> </svg> <span class="floating-menu_label">Edit attribute</span>',
  '',
  'class="floating-menu_item" onclick="{editAttribute}"', function(opts) {
'use strict';

var _this = this;

var _attributesUi = require('lib/node/attributes-ui');

var _eventTracking = require('lib/event-tracking');

var _eventTracking2 = _interopRequireDefault(_eventTracking);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

this.editAttribute = function (e) {
  e.preventDefault();
  e.stopPropagation();
  var nodeTag = _this.parent.parentNodeTag;
  if (!nodeTag) return;
  var attributeId = canvas.nodeAttributeTags[nodeTag.id].attributeId;

  var referenceEl = nodeTag.refs.container;
  if (nodeTag.tags && nodeTag.tags['node-attributes']) {
    referenceEl = nodeTag.tags['node-attributes'].root;
    // don't open panel all the way off the edge of a big card
  }

  canvas.nodeAttributeEditor.summon({
    referenceEl: referenceEl,
    node: nodeTag.instance,
    attributeId: _this.parent.attributeId,
    isEditing: true,
    positionToLeft: appUI.positionSubMenuToLeft({ positionReferenceElement: referenceEl })
  });

  _this.parent.hide();

  _eventTracking2.default.track({
    category: 'Attributes',
    action: 'Attr-Menu-Single-Edit-Open',
    label: 'Attribute-Editor-Opened'
  });
};
});

    
  if (module.hot) {
    module.hot.accept()
    if (module.hot.data) {
      riot.reload('menu-item-edit-attribute')
    }
  }
  


//////////////////
// WEBPACK FOOTER
// ./starling/src/tags/menu/items/menu-item-edit-attribute.html
// module id = 703
// module chunks = 0